var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_data_obj = function (op) {
    var implements = [];
    if (!op) {
        op = {};
    }
    if (OCS.Utilities.is_string(op)) {
        try {
            // Try to decode the data
            op = JSON.parse(op);
        } catch (err) {
            console.error("Data: " + err);
            op = {};
        }
    }
    var method = OCS.Functions.define_Data_class;
    if (op.data_type) {
        // We have a defined datatype, use that to determine the class we need to base off of
        var data_type = op.data_type;
        delete op.data_type;
        var method_name = "define_" + data_type + "_class";
        if (OCS.Functions[method_name]) {
            method = OCS.Functions[method_name];
        }
    }

    // Determine what functionality we need to include based on the dataset
    var datatype_defined = false;
    if (op.entry && op.entry.json && op.entry.json.dataset) {
        var dataset = OCS.Functions.get_dataset_from_node(op.entry.json.dataset);
        if (dataset && dataset.class_type === "Dataset") {
            switch (dataset.get_datatype()) {
                case "netcdf":
                    datatype_defined = true;
                    if (op.entry.json.info && op.entry.json.info.grid) {
                        implements.push(new Class(OCS.Interfaces.DataTypeNetcdfGridded));
                    } else {
                        implements.push(new Class(OCS.Interfaces.DataTypeNetcdf));
                    }
                    break;
                case "nids":
                    datatype_defined = true;
                    implements.push(new Class(OCS.Interfaces.DataTypeNids));
                    break;
                case "shapefile":
                    datatype_defined = true;
                    implements.push(new Class(OCS.Interfaces.DataTypeShape));
                    method = OCS.Functions.define_GeoJsonData_class;
                    break;
                case "advisories":
                    datatype_defined = true;
                    implements.push(new Class(OCS.Interfaces.DataTypeAdvisory));
                    method = OCS.Functions.define_GeoJsonData_class;
                    break;                
                case "lightning":
                    datatype_defined = true;
                    implements.push(new Class(OCS.Interfaces.DataTypeLightning));
                    method = OCS.Functions.define_GeoJsonData_class;
                    break;
            }
        } 
    }
    if(!datatype_defined) {
        implements.push(new Class(OCS.Interfaces.DataTypeDefault));
    }

    var class_obj = method(implements);
    return new class_obj(op);
};